(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oct26-charity"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-oct26-charity]').forEach(function (root) {
  var goal = parseFloat(root.dataset.goal || '0');
  var elTotal = root.querySelector('[data-total]');
  var elBar = root.querySelector('[data-bar]');
  var elPct = root.querySelector('[data-pct]');

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-AU');
  }

  function paint(n) {
    if (elTotal) elTotal.textContent = money(n);
    var pct = goal > 0 ? Math.min(100, (n / goal) * 100) : 0;
    if (elBar) elBar.style.width = pct + '%';
    if (elPct) elPct.textContent = Math.round(pct) + '% of the way there';
  }

  paint(parseFloat(root.dataset.fallback || '0'));

  var url = root.dataset.endpoint;
  if (!url) return;
  fetch(url, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d) return;
      // accepts { total: 2500 } or a bare number, whichever the function returns
      var n = typeof d === 'number' ? d : parseFloat(d[root.dataset.key]);
      if (!isNaN(n)) paint(n);
    })
    .catch(function () { /* fallback already on screen */ });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oct26-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-oct26-faq]').forEach(function (list) {
  list.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t.tagName !== 'DETAILS' || !t.open) return;
    list.querySelectorAll('details[open]').forEach(function (d) { if (d !== t) d.open = false; });
  }, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oct26-starterpack"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-oct26-pack]').forEach(function (root) {
  var items = Array.prototype.slice.call(root.querySelectorAll('.oct26-pack__item'));
  var btns = Array.prototype.slice.call(root.querySelectorAll('.oct26-pack__size'));
  var threshold = Math.round(parseFloat(root.dataset.threshold || '0') * 100);
  var nextWrap = root.querySelector('[data-next]');
  var nextText = root.querySelector('.oct26-pack__nexttext');
  var bar = root.querySelector('[data-bar]');
  var giftName = root.dataset.giftName || '';
  var nextInc = root.querySelector('[data-nextinc]'), nextValue = 0;
  if (nextInc) {
    nextValue = Math.round(parseFloat(nextInc.querySelector('i').textContent.replace(/[^0-9.]/g, '')) * 100) || 0;
    // sit with the other gifts, above "Free shipping"
    var plain = Array.prototype.filter.call(nextInc.parentNode.children, function (li) { return !li.querySelector('i'); })[0];
    if (plain) nextInc.parentNode.insertBefore(nextInc, plain);
  }

  // "M|309|185.40" per line -> { M: [30900, 18540] }. Cents throughout: adding
  // 185.40 + 69.30 + 39.98 as floats does not reliably land on 294.68.
  function parse(el) {
    var map = {};
    (el.dataset.prices || '').split('\n').forEach(function (line) {
      var p = line.split('|');
      if (p.length < 3) return;
      map[p[0].trim().toUpperCase()] = [
        Math.round(parseFloat(p[1]) * 100),
        Math.round(parseFloat(p[2]) * 100)
      ];
    });
    return map;
  }
  items.forEach(function (el) { el._p = parse(el); });

  // whole dollars print without cents, matching the design: $309, not $309.00
  function money(c) {
    var s = (c % 100 === 0) ? String(c / 100) : (c / 100).toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // free gift RRPs listed in "Plus, on the house" count toward the saving
  var giftValue = 0;
  root.querySelectorAll('.oct26-pack__inc li:not([data-nextinc]) i').forEach(function (el) {
    var v = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    if (!isNaN(v)) giftValue += Math.round(v * 100);
  });

  function render(size, name) {
    var was = 0, now = 0;
    items.forEach(function (el) {
      // ALL is the fallback row for anything that does not change with size
      var row = el._p[size] || el._p.ALL;
      var w = el.querySelector('[data-was]'), n = el.querySelector('[data-now]');
      if (!row) { if (w) w.textContent = ''; if (n) n.textContent = ''; return; }
      was += row[0]; now += row[1];
      if (w) w.textContent = money(row[0]);
      if (n) n.textContent = money(row[1]);
    });

    var sn = root.querySelector('[data-sizename]');
    if (sn) sn.textContent = name;
    var pw = root.querySelector('[data-packwas]');
    if (pw) pw.textContent = money(was);
    var pn = root.querySelector('[data-packnow]');
    if (pn) pn.textContent = money(now);
    var sv = root.querySelector('[data-save]');
    var unlocked = threshold > 0 && now >= threshold;
    if (nextInc) nextInc.hidden = !unlocked;
    if (sv) sv.textContent = money(was - now + giftValue + (unlocked && nextInc ? nextValue : 0));

    if (nextWrap && threshold > 0) {
      var gap = threshold - now;
      if (gap > 0) {
        nextWrap.hidden = false;
        nextText.innerHTML = 'Add <b>' + money(gap) + '</b> more and the ' + giftName + ' is free too.';
        bar.style.width = Math.min(100, (now / threshold) * 100) + '%';
      } else {
        nextWrap.hidden = false;
        nextText.innerHTML = 'The ' + giftName + ' is unlocked.';
        bar.style.width = '100%';
      }
    }
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      btns.forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
      render(b.dataset.size.toUpperCase(), b.dataset.name);
    });
  });

  var start = root.querySelector('.oct26-pack__size.is-on') || btns[0];
  if (start) render(start.dataset.size.toUpperCase(), start.dataset.name);
});

  } catch(e) { console.error(e); }
})();
})();
